import AllFiltersScrollButton from "components/pages/sectionNew/filterBlock/mobile/allFiltersScrollButton";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import FilterPopup from "~/components/pages/sectionNew/filterBlock/mobile/filterPopup";
import MarkSelector from "~/components/pages/sectionNew/filterBlock/mobile/markSelector";
import useIsMobile from "~/hooks/useIsMobile";

import Filter from "./filter";
import styles from "./index.module.scss";
import Selector from "./selector";

const mobileFilterTypes = {
  marka: "marka",
  model: "model",
  kuzov: "kuzov",
  filter: "filter",
};

export default function FilterBlock({ section = {}, productCount = 0 }: any) {
  const { params } = useSelector((state: any) => state.filter);
  const { isMobile } = useIsMobile();
  const { marks } = useSelector((state: any) => state.models);

  const markKeys = Object.keys(marks).sort();

  const totalCheckedCnt = useMemo(() => {
    return Object.keys(params).filter(
      (param) => !["marka", "model", "kuzov"].includes(param),
    ).length;
  }, [params]);

  const [isShowMobileFilterPopup, setShowMobileFilter] = useState(false);

  useEffect(() => {
    const body: any = document.querySelector("body");
    if (!isShowMobileFilterPopup) {
      body.classList.remove("filterPopup");
    } else {
      body.classList.add("filterPopup");
    }
  }, [isShowMobileFilterPopup]);

  const mobileFilterType = useMemo(() => {
    if (markKeys.length > 0) {
      if (!params?.marka) {
        return mobileFilterTypes.marka;
      }
      if (!params?.model) {
        return mobileFilterTypes.model;
      }
      if (!params?.kuzov) {
        return mobileFilterTypes.kuzov;
      }
    }
    return mobileFilterTypes.filter;
  }, [params, marks, markKeys]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    document.getElementById("popupBody")?.scrollTo({ top: 0 });
    if (mobileFilterType === mobileFilterTypes.filter) {
      setShowMobileFilter(false);
    }
  }, [mobileFilterType]);

  const router = useRouter();

  // @ts-ignore
  return (
    <>
      {!isMobile && (
        <div className={styles.Wrapper}>
          <Selector sectionPageUrl={section.SECTION_PAGE_URL} />
          <Filter
            productCount={productCount}
            sectionPageUrl={section.SECTION_PAGE_URL}
            onChangeUrl={(newUrl: string) => {
              router.push(newUrl);
            }}
          />
        </div>
      )}
      {isMobile && (
        <>
          <MarkSelector
            sectionPageUrl={section.SECTION_PAGE_URL}
            onShow={() => {
              setShowMobileFilter(true);
            }}
          />
          {mobileFilterType === mobileFilterTypes.filter && (
            <>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <div
                className={styles.AllFiltersButton}
                onClick={() => {
                  setShowMobileFilter(!isShowMobileFilterPopup);
                }}
              >
                <svg
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 4L13 4M13 4C13 5.65686 14.3431 7 16 7C17.6569 7 19 5.65685 19 4C19 2.34315 17.6569 1 16 1C14.3431 1 13 2.34315 13 4ZM7 12L19 12M7 12C7 13.6569 5.65685 15 4 15C2.34315 15 1 13.6569 1 12C1 10.3431 2.34315 9 4 9C5.65685 9 7 10.3431 7 12Z"
                    stroke="#1247A5"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Все фильтры{" "}
                {totalCheckedCnt > 0 && <span>{totalCheckedCnt}</span>}
              </div>
            </>
          )}
          {isShowMobileFilterPopup && (
            <FilterPopup
              productCount={productCount}
              sectionPageUrl={section.SECTION_PAGE_URL}
              mobileFilterType={mobileFilterType}
              mobileFilterTypes={mobileFilterTypes}
              onHide={() => {
                setShowMobileFilter(false);
              }}
            />
          )}
          <AllFiltersScrollButton
            isShowMobileFilterPopup={isShowMobileFilterPopup}
            mobileFilterType={mobileFilterType}
            mobileFilterTypes={mobileFilterTypes}
            onShow={() => {
              setShowMobileFilter(true);
            }}
          />
        </>
      )}
    </>
  );
}
